export default {
  "home": "홈",
  "news": "최신 정보",
  "community": "커뮤니티",
  "character": "캐릭터",
  "world": "세계관",
  "features": "게임 소개",
  "topUp": "충전",
  "customerService": "고객센터",
  "download": "다운로드",
  "moreDownload": "더 보기",
  "screenshot": "스크린샷",
  "video": "동영상",
  "poster": "포스터",
  "downloadGame": "다운로드",
  "scan": "QR코드를 스캔하세요",
  "prev": "이전",
  "next": "다음",
  "moreNews": "더 보기",
  "latest": "최신",
  "fwtk": "서비스 약관",
  "yszc": "개인정보 취급 방침",
  "noContent": "준비 중",
  "goPay": "이동",
  "payGuide": "확인",
  "stayTurn": "준비 중",
  "hero1": "리처드",
  "hero1_text": "사자왕 리처드 1세는 1189년 7월 6일 영국의 국왕이 됐다. 리처드는 광적인 군사 애호가였으며, 여러 전투를 거듭하며 군수품을 약탈해왔다.",
  "hero1_skill1": "십자군의 왕",
  "hero1_skill2": "왕의 호위병",
  "hero1_skill3": "사자의 심장",
  "hero1_skill4": "힘의 비축",
  "hero2": "알렉산더 대왕",
  "hero2_text": "마케도니아의 알렉산더 3세는 알렉산더 대왕이라 불리며, 고대 그리스 마케도니아의 국왕이자, 고대 그리스의 유명 왕실 아지드 왕조의 일원이다. 기원전 356년 펠라에서 태어난 알렉산더는 20살에 아버지 필리프 2세로부터 권위를 물려받았고, 전에 없었던 규모의 군사 정복을 진행했다.",
  "hero2_skill1": "신의 아들",
  "hero2_skill2": "헤타이로이",
  "hero2_skill3": "고독한 싸움",
  "hero2_skill4": "모루 전술",
  "hero3": "화목란",
  "hero3_text": "화목란은 중국 역사상 유명한 여장부이다. 북위 시기, 북방 유목 민족은 끊임없이 남쪽으로 내려와 소란을 피웠고, 북위 정권은 집마다 남성 한 명을 보내 전선에 합류하길 지시했다. 하지만 화목란의 아버지는 늙고 병이 들어 싸울 수 없었고, 남동생은 나이가 어렸다. 화목란은 아버지를 대신해 군대에 합류하기로 했으며, 그때부터 십여 년의 군대 생활을 시작했다.",
  "hero3_skill1": "기사무쌍",
  "hero3_skill2": "여장부",
  "hero3_skill3": "체부종군",
  "hero3_skill4": "나라 수호",
  "hero4": "선덕여왕",
  "hero4_text": "선덕여왕, 이름은 김덕만으로, 진평왕의 장녀이자 신라의 제27대 왕이다(632년~647년 재위). 신라 최초의 여왕으로, 어질고 총명했다고 한다.",
  "hero4_skill1": "자비심",
  "hero4_skill2": "기민한 사고",
  "hero4_skill3": "통찰력",
  "hero4_skill4": "사면령",
  "hero5": "오다 노부나가",
  "hero5_text": "오다 노부나가(1534년 5월 24일~1582년 6월 3일)는 일본 전국시대부터 아즈치 모모야마 시대를 호령한 다이묘로, 1568년부터 사망 직전까지 일본의 정세를 장악하기 위해 200여 년 동안 일본을 다스리던 아시카가 막부를 끌어내렸고, 응인의 난에서 시작되어 100년 이상 지속된 난세를 종결시켰다. 일본 역사에서 도요토미 히데요시, 도쿠가와 이에야스와 함께 ‘전국 삼걸’로 불린다.",
  "hero5_skill1": "천하포무",
  "hero5_skill2": "결계술",
  "hero5_skill3": "되치기",
  "hero5_skill4": "무사도",
  "hero6": "잔 다르크",
  "hero6_text": "성녀 잔 다르크는 프랑스의 군사가이자 천주교의 성인이며 영국-프랑스 백년전쟁에서 활약한 프랑스의 민족 영웅이다. 잔 다르크는 13세가 되던 어느 날 마을 뒤의 나무 밑에서 영국인들이 점령한 프랑스의 땅을 되찾으라는 하느님의 계시를 받았다고 한다.",
  "hero6_skill1": "천사의 강림",
  "hero6_skill2": "성녀",
  "hero6_skill3": "신념",
  "hero6_skill4": "신성의 가호",
  "roleMainTitle": "제국의 역사를 재현하라!",
  "roleSubTitle": "세계 각국 전설 속 영웅을 모집해 패업을 이루세요!",
  "back": "돌아가기",
  "slogan": "나만의 제국을 건설하라",
}
